import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/brokerage-administration',
    name: ROUTES.BROKER_ADMIN_SELECT,
    component: () => import('../views/brokerage-admin/BrokerageAdminSelect'),
  },
  {
    path: '/brokerage-administration/:brokerCode',
    name: ROUTES.BROKER_ADMIN,
    component: () => import('../views/brokerage-admin/BrokerageAdministration'),
  },
  {
    path: '/brokerage-administration/:brokerCode/configuration',
    name: ROUTES.BROKER_CONFIG,
    component: () => import('../views/brokerage-admin/BrokerageConfiguration'),
  },
  {
    path: '/brokerage-administration/:brokerCode/users/pictures',
    name: ROUTES.BROKER_PICTURES,
    component: () => import('../views/brokerage-admin/BrokeragePictures.vue'),
  },
  {
    path: '/brokerage-administration/:brokerCode/accounts/:accountCode/users',
    name: ROUTES.BROKER_ADMIN_USERS,
    component: () => import('../views/brokerage-admin/BrokerageAdminAccountUsers'),
  },
  {
    path: '/brokerage-administration/:brokerCode/billing',
    name: ROUTES.BROKER_BILLING,
    component: () => import('../views/brokerage-admin/BrokerageBilling'),
  },
  {
    path: '/brokerage-administration/:brokerCode/accounts',
    name: ROUTES.BROKER_ACCOUNTS,
    component: () => import('../views/brokerage-admin/BrokerageAccounts'),
  },
  {
    path: '/brokerage-administration/:brokerCode/application-library',
    name: ROUTES.BROKER_APP_LIB,
    component: () => import('../views/brokerage-admin/BrokerageAdminAppLibrary'),
  },
  {
    path: '/brokerage-administration/:brokerCode/data',
    name: ROUTES.BROKER_DATA,
    component: () => import('../views/brokerage-admin/BrokerageData'),
  },

  {
    path: '/brokerage-administration/:brokerCode/configuration/schedule-columns',
    name: ROUTES.BROKER_SCHEDULE_COLS,
    component: () => import('../views/brokerage-admin/BrokerageScheduleColumns'),
  },

  {
    path: '/brokerage-administration/:brokerCode/configuration/schedule-export',
    name: ROUTES.BROKER_SCHEDULE_EXPORT,
    component: () => import('../views/brokerage-admin/BrokerageScheduleExport'),
  },

  {
    path: '/brokerage-administration/:brokerCode/global-policy-management',
    name: ROUTES.BROKER_GLOBAL_POLICY_MANAGEMENT,
    component: () => import('../views/brokerage-admin/BrokerageGlobalPolicyManagement'),
  },

  {
    path: '/brokerage-administration/:brokerCode/global-policy-management/:globalPolicyId',
    name: ROUTES.BROKER_GLOBAL_POLICY_DETAIL,
    component: () => import('../views/brokerage-admin/BrokerageGlobalPolicyDetail'),
  },
]
